import { useContext, useState, useEffect } from 'react'
import { faChevronLeft, faGear, faScaleBalanced, faUsers } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { ApplicationContext } from 'context'

import Layout from 'components/Layout'
import AgencySettings from 'components/Settings'
import Employees from 'components/Employees'
import SettingsPermissions from "components/SettingsPermissions"
// import { discectError } from 'lib/utils'


const Settings = () => {
  const { contextLoading, contextError, contextAgency, useCurrentPath } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [_, setError] = contextError // eslint-disable-line
  const [agency] = contextAgency // eslint-disable-line
  const [tab, setTab] = useState('SETTINGS')
  // const navigate = useNavigate();

  const currentPath = useCurrentPath()

  useEffect(()=> {
    if(currentPath === '/settings') {
      setTab('SETTINGS')
    } else if (currentPath === '/settings/employees') {
      setTab('EMPLOYEES')
    } else if (currentPath === '/settings/permissions') {
      setTab('PERMISSIONS')
    }
  }, [currentPath])

  const navigation = [
    {
      title: 'Back',
      icon: <FontAwesomeIcon icon={faChevronLeft} />,
      path: '/dashboard',
      sub: []
    },
    {
      title: 'Settings',
      type: 'TITLE',
    },
    {
      title: 'General',
      icon: <FontAwesomeIcon icon={faGear} />,
      path: '/settings',
      sub: []
    },
    {
      title: 'Employees',
      icon: <FontAwesomeIcon icon={faUsers} />,
      path: '/settings/employees',
      sub: []
    },
    {
      title: 'Permissions',
      icon: <FontAwesomeIcon icon={faScaleBalanced} />,
      path: '/settings/permissions',
      sub: []
    }
  ]
  
  let content = null
  if (agency) {
    content = (
      <>
        {tab === 'SETTINGS' && <AgencySettings agency={agency}/> }
        {tab === 'EMPLOYEES' && <Employees agency={agency}/>}
        {tab === 'PERMISSIONS' && <SettingsPermissions agency={agency}/>}
      </>
    )
  }

  return (
    <Layout navigation={navigation}>
      {content}
    </Layout>
  )
}

export default Settings
